module.exports = __webpack_public_path__ + "static/media/allianz-parque3.27cc7398.jpg";